import { c as _c } from "react/compiler-runtime";
import { renderStructuredContent } from '../../renderContext';
import type { StructuredContentDocument, StructuredContentDocumentWithRenderer } from '../../types';
export type DocumentProps = StructuredContentDocumentWithRenderer<{
  spacing?: {
    top?: number;
    bottom?: number;
  };
  inline?: boolean;
  children: StructuredContentDocument;
}>;
export function Document(t0) {
  const $ = _c(6);
  const {
    props
  } = t0;
  let t1;
  if ($[0] !== props.children) {
    t1 = renderStructuredContent(props.children);
    $[0] = props.children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const content = t1;
  if (props.inline) {
    let t2;
    if ($[2] !== content) {
      t2 = <>{content}</>;
      $[2] = content;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t2;
  if ($[4] !== content) {
    t2 = <div>{content}</div>;
    $[4] = content;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}